import a11ypanel from "../../../../assets/images/docs/a11ypanel.png";
import * as React from 'react';
export default {
  a11ypanel,
  React
};